exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-container[data-v-3e0c9f14] {\r\n  padding: 10px;\r\n  padding-bottom: 30px;\n}\n.list[data-v-3e0c9f14] {\r\n  margin: 0 20px;\n}\n.item[data-v-3e0c9f14] {\r\n  margin: 10px 0;\n}\n.clearfix[data-v-3e0c9f14]:before,\r\n.clearfix[data-v-3e0c9f14]:after {\r\n  display: table;\r\n  content: \"\";\n}\n.clearfix[data-v-3e0c9f14]:after {\r\n  clear: both\n}\r\n", ""]);

// exports
